import { render, staticRenderFns } from "./aboutUs_details.vue?vue&type=template&id=e35fc124&scoped=true&"
import script from "./aboutUs_details.vue?vue&type=script&lang=js&"
export * from "./aboutUs_details.vue?vue&type=script&lang=js&"
import style0 from "./aboutUs_details.vue?vue&type=style&index=0&id=e35fc124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35fc124",
  null
  
)

export default component.exports